/**
 * 灵图异步任务轮询（/lingtu-image/result）。
 * 供图片处理 Studio（放大、抠图等）使用，与图案裁剪主链（Qwen Worker batch）无关。
 */
import { lingtuImageAPI } from '@/utils/api';
import { IMAGE_CROP_POLL_INTERVAL_MS } from '../constants/imageCropConfig';

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

function pickUrl(obj) {
  if (!obj || typeof obj !== 'object') return '';
  if (Array.isArray(obj.urls) && obj.urls.length > 0) {
    const first = obj.urls[0];
    if (first && typeof first === 'object' && first.url) return String(first.url);
    return String(first || '');
  }
  if (obj.url) return String(obj.url);
  if (obj.image) return String(obj.image);
  if (obj.resultUrl) return String(obj.resultUrl);
  if (obj.imageUrl) return String(obj.imageUrl);
  if (Array.isArray(obj.images) && obj.images.length > 0) {
    const first = obj.images[0];
    if (first && typeof first === 'object' && first.url) return String(first.url);
    return String(first || '');
  }
  if (obj.task_result && Array.isArray(obj.task_result.images) && obj.task_result.images.length > 0) {
    const first = obj.task_result.images[0];
    if (first && typeof first === 'object' && first.url) return String(first.url);
  }
  return '';
}

export function extractLingtuOutputUrl(result) {
  if (!result) return '';
  const sub = result.result;
  const data = result.data && typeof result.data === 'object' ? result.data : null;
  const fromData = pickUrl(data);
  if (fromData) return fromData;
  if (result.data || result.base64) {
    const base64 = result.data || result.base64;
    if (typeof base64 === 'string' && base64.includes('data:')) return base64;
    if (typeof base64 === 'string' && /^[A-Za-z0-9+/=]+$/.test(base64.trim())) {
      return `data:image/png;base64,${base64}`;
    }
  }
  const direct = pickUrl(result);
  if (direct) return direct;
  if (sub && (sub.image || sub.url || sub.data || sub.base64)) {
    if (sub.data || sub.base64) {
      const base64 = sub.data || sub.base64;
      return String(base64).includes('data:') ? base64 : `data:image/png;base64,${base64}`;
    }
    return sub.image || sub.url || '';
  }
  return '';
}

/**
 * @returns {{ ok: boolean, url?: string, message?: string, rawResult?: object }}
 */
export async function pollLingtuJob(jobId, { maxAttempts = 55, intervalMs = IMAGE_CROP_POLL_INTERVAL_MS } = {}) {
  const id = String(jobId || '').trim();
  if (!id) return { ok: false, message: '无任务 ID' };
  for (let i = 0; i < maxAttempts; i += 1) {
    try {
      const rs = await lingtuImageAPI.getResult(id);
      const st = String(rs?.status || '').toLowerCase();
      if (st === 'succeed' || st === 'success' || st === 'completed') {
        const url = extractLingtuOutputUrl(rs);
        if (url) return { ok: true, url, rawResult: rs };
        return { ok: false, message: '灵图返回成功但无图片地址' };
      }
      if (st === 'failed' || st === 'failure' || st === 'canceled' || st === 'cancelled') {
        return { ok: false, message: rs?.message || rs?.msg || '灵图处理失败' };
      }
    } catch {
      /* 继续轮询 */
    }
    await sleep(intervalMs);
  }
  return { ok: false, message: '灵图处理超时' };
}
